 <div class="d-flex justify-content-between mb-2">
    <button class="btn btn-primary btn-sm text-xxs" data-bs-toggle="modal" data-bs-target="#discussion_modal">Start discussion</button>
  </div> 

 <div v-for="topic in disscussion_topics" :key="topic.id"
              class="card card-hover mb-4 p-3 d-flex flex-column border-bottom rounded-5 border-0 full-width-mobile shadow" @click="display_comment_modal(topic)">
              <div class="row">
                <div class="col">
                  <div class="d-flex flex-start">
                    <i class='bx bxs-user-circle text-secondary fs-1'></i>
                    <div class="flex-grow-1 flex-shrink-1">
                      <div>
                        <div class="d-flex justify-content-between align-items-center">
                          <p class="fw-500 mt-1 lh-1 text-xs"><span>{{ topic.created_by_name }}</span>
                            <span
                              class="badge bg-warning text-dark mx-2 text-white shadow-sm">
                            </span><br><span class="text-xxs"><i
                                class="bx bxs-stopwatch"></i> {{ topic.date_created }}</span>
                          </p>
                          <div class="dropstart" @click.stop>
                            <a href="" class="fw-bold text-dark" id="dropdownMenuButton" data-bs-toggle="dropdown"
                              aria-expanded="false">
                              <i class="bi bi-three-dots-vertical"></i><span class="small"></span>
                            </a>
                            <ul class="dropdown-menu custom-dropdown lh-1" aria-labelledby="dropdownMenuButton">
                                 <li><a class="dropdown-item" href="#" @click.prevent="edit_topic(topic)">Edit</a></li>
                                 <li><a class="dropdown-item text-danger" href="#" @click.prevent="delete_topic(topic.id)">Delete</a></li>
                            </ul>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <h6 class="fw-500">{{ topic.name }}</h6>
                  <div class="text-gray mx-2 mt-1 text-end">
                    <span class="me-2 mt-1"> <i class='bx bxs-like'></i></span>
                    <span>{{ topic.comments_count }} <i class='bx bxs-comment'></i></span>
                  </div>
                  <div class="d-flex justify-content-between align-items-center ">
                    <div class="mb-3 ms-2 me-3 mt-1">
                       <i class='bx bxs-like fs-5'></i>
                    </div>

                    <div class="input-group mb-3 me-2 rounded-5 w-100 position-relative mt-1"
                      @click="display_comment_modal(topic)">

                      <input type="text" class="form-control text-xxs rounded-start rounded-end"
                        placeholder="Write a comment .." readonly>
                    </div>
                  </div>

                </div>
              </div>
            </div>

  <div class="modal fade" id="discussion_modal" tabindex="-1" aria-labelledby="discussion_modalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded-5 border-0 shadow-sm">
      <div class="modal-header">
        <h5 class="modal-title" id="discussion_modalLabel">Create a discussion</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <!-- <form> -->
      <div class="modal-body">
        <form @submit.prevent="create_discussion_topic">
        <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label text-xs">Topic question <span class="text-danger">*</span></label>
            <input type="text" class="form-control form-control-sm text-xxs rounded-3 shadow-sm" id="exampleFormControlInput1" placeholder="Enter discussion topic" v-model="topic_name">
            </div>
            <div class="mb-3">
                <label for="exampleFormControlTextarea1" class="form-label text-xxs">Description</label>
                <textarea class="form-control" id="exampleFormControlTextarea1 rounded-3 shadow-sm" rows="3" v-model="description"></textarea>
            </div>
            <div class="float-end">
                 <button type="submit" class="btn btn-primary btn-sm text-xxs" data-bs-dismiss="modal">Save</button>
            </div>
            </form>
      </div>
    
      <!-- </form> -->
    </div>
  </div>
</div>

<div class="modal fade" id="editTopicModal" tabindex="-1" aria-labelledby="editTopicModalLabel" aria-hidden="true" >
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded-5 border-0 shadow-sm">
      <div class="modal-header border-0">
        <h6 class="modal-title" id="editTopicModalLabel">Edit Topic</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button>
      </div>
      <div class="modal-body">
       <input v-model="editTopicData.title" class="form-control mb-2 text-xxs rounded-3 shadow-sm" placeholder="Title" />
       <textarea v-model="editTopicData.description" class="form-control text-xxs rounded-3 shadow-sm" placeholder="Description"></textarea>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary btn-sm text-xxs" @click="saveTopicEdits" data-bs-dismiss="modal">Save</button>
      </div>
    </div>
  </div>
</div>

<DisscussionComment v-if="comment_modal_visible" :discussion="report_data" @hide_comment="hide_comment"/>